import { F as i } from "./FocusGroup-CysiCtsR.js";
class r extends i {
  constructor() {
    super(...arguments), this.managed = !0, this.manageIndexesAnimationFrame = 0;
  }
  set focused(e) {
    e !== this.focused && (super.focused = e, this.manageTabindexes());
  }
  get focused() {
    return super.focused;
  }
  clearElementCache(e = 0) {
    cancelAnimationFrame(this.manageIndexesAnimationFrame), super.clearElementCache(e), this.managed && (this.manageIndexesAnimationFrame = requestAnimationFrame(() => this.manageTabindexes()));
  }
  manageTabindexes() {
    this.focused ? this.updateTabindexes(() => ({ tabIndex: -1 })) : this.updateTabindexes((e) => ({ removeTabIndex: e.contains(this.focusInElement) && e !== this.focusInElement, tabIndex: e === this.focusInElement ? 0 : -1 }));
  }
  updateTabindexes(e) {
    this.elements.forEach((a) => {
      const { tabIndex: t, removeTabIndex: n } = e(a);
      if (!n) return void (this.focused ? a !== this.elements[this.currentIndex] && (a.tabIndex = t) : a.tabIndex = t);
      a.removeAttribute("tabindex");
      const s = a;
      s.requestUpdate && s.requestUpdate();
    });
  }
  manage() {
    this.managed = !0, this.manageTabindexes(), super.manage();
  }
  unmanage() {
    this.managed = !1, this.updateTabindexes(() => ({ tabIndex: 0 })), super.unmanage();
  }
  hostUpdated() {
    super.hostUpdated(), this.host.hasUpdated || this.manageTabindexes();
  }
}
export {
  r as R
};
//# sourceMappingURL=RovingTabindex-CrzUW4Ci.js.map
